import { call, put, delay } from "redux-saga/effects";
import { userApi } from "@services/api";
import { getProfileActions, updateProfileActions } from "../slices";
import {
  rejectLoadingToast,
  resolveLoadingToast,
  startLoadingToast,
} from "@helpers";

function* updateProfileWorker({ payload }) {
  const toastId = startLoadingToast("Updating your profile");
  yield put(updateProfileActions.pending());
  yield delay(300);
  try {
    const response = yield call(userApi.updateProfile, payload);
    yield put(getProfileActions.update(response));
    yield put(updateProfileActions.success({ toastId }));
    // TODO: handle callback | onSuccess
    resolveLoadingToast(toastId, "Update profile successfully!");
  } catch (error) {
    yield put(updateProfileActions.failure({ toastId }));
    // TODO: handle callback | onFailure
    rejectLoadingToast(
      toastId,
      "Update profile failed, Please try again later."
    );
  }
}

export { updateProfileWorker };
